import { createContext, useContext, useReducer } from "react";
import { initialInvitationState, InvitationReducer } from "../../Components/OrganizationSettings/InvitationManagement/InvitationReducer";

const InvitationContext = createContext();

export const InvitationProvider = ({ children }) => {
    const [state, dispatch] = useReducer(InvitationReducer, initialInvitationState);
    return (
        <InvitationContext.Provider value={{ state, dispatch }}>
            {children}
        </InvitationContext.Provider>
    );
};

export const useInvitation = () => {
    const context = useContext(InvitationContext); 
    if (!context) {
        throw new Error('useInvitation must be used within a InvitationProvider');
    }
    return context;
}